import {offeredProviders, ProductViewModel, SellableEdition} from "../../api/models";
import {useShop} from "../../components/ShopContext";
import {language, products} from "../../i18n";

const orList = new Intl.ListFormat(language, { type: 'disjunction' });

// Whether a product can be bought online here, now: the shop's open, the product's not in beta, it has a price for the
// edition sold online, and a payment provider's set up. With the ways to pay, for the terms under the button.
export function useSale(product: ProductViewModel | undefined) {
    const {open: shopOpen, config: checkout} = useShop();
    const salePrice = product && !product.beta ? product.prices.find(x => x.edition === SellableEdition && x.amount > 0) : undefined;
    const offered = offeredProviders(checkout);
    const canBuy = shopOpen && !!salePrice && offered.length > 0;
    // Paddle's checkout takes both.
    const paymentMethods = orList.format([
        (offered.includes('stripe') || offered.includes('paddle')) && products.page.paymentMethods.card,
        (offered.includes('paypal') || offered.includes('paddle')) && products.page.paymentMethods.paypal
    ].filter((x): x is string => !!x));
    return { canBuy, salePrice, paymentMethods };
}

export const checkoutPath = (product: ProductViewModel) => `/checkout/${encodeURIComponent(product.sku)}`;
